(function () {
  'use strict';

  var dialog = document.querySelector('dialog[data-frame-wishlist]');
  if (!dialog || dialog.dataset.frameInitialized === 'true') return;
  dialog.dataset.frameInitialized = 'true';

  var ar = (dialog.dataset.language || document.documentElement.lang || '').split('-')[0] === 'ar';
  var copy = ar ? {
    title: 'المفضلة', close: 'إغلاق المفضلة', loading: 'جارٍ تحميل المفضلة…',
    loadError: 'تعذّر تحميل المفضلة. لم تتغيّر العناصر المحفوظة.',
    unavailable: 'خدمة المفضلة غير متاحة حالياً. لم تتغيّر العناصر المحفوظة.',
    timeout: 'استغرق الطلب وقتاً أطول من المتوقع. يرجى المحاولة مجدداً.',
    retry: 'إعادة المحاولة', empty: 'قائمة المفضلة فارغة.', browse: 'متابعة التسوق',
    products: 'العناصر المحفوظة', list: 'قائمة المفضلة', item: 'عنصر', items: 'عناصر',
    view: 'عرض المنتج واختيار المقاس', remove: 'إزالة', removing: 'جارٍ الإزالة…',
    removed: 'تمت إزالة العنصر من المفضلة.', removeError: 'تعذّرت إزالة العنصر. يرجى المحاولة مجدداً.',
    add: 'إضافة إلى المفضلة', removeSaved: 'إزالة من المفضلة', saving: 'جارٍ تحديث المفضلة…',
    added: 'تمت إضافة المنتج إلى المفضلة.', saveError: 'تعذّر تحديث المفضلة. يرجى المحاولة مجدداً.',
    product: 'منتج محفوظ', productUnavailable: 'هذا المنتج غير متاح حالياً.',
    productDetails: 'اطّلع على صفحة المنتج لمعرفة المقاسات والتوفّر الحالي.',
    productRefreshError: 'تعذّر تحديث تفاصيل المنتج. افتح صفحة المنتج للاطّلاع على أحدث المعلومات.',
    share: 'إنشاء رابط عام', sharing: 'جارٍ إنشاء الرابط…', link: 'رابط المفضلة',
    shareNotice: 'يمكن لأي شخص لديه الرابط الاطّلاع على هذه القائمة.',
    linkReady: 'الرابط جاهز. انسخه لمشاركته.', copy: 'نسخ الرابط', copied: 'تم نسخ الرابط.',
    manualCopy: 'حدّد الرابط وانسخه.', shareError: 'تعذّر إنشاء رابط المشاركة. يرجى المحاولة مجدداً.'
  } : {
    title: 'Wishlist', close: 'Close wishlist', loading: 'Loading your wishlist…',
    loadError: "We couldn't load your wishlist. Your saved items haven't changed.",
    unavailable: "Wishlist is unavailable right now. Your saved items haven't changed.",
    timeout: 'This is taking longer than expected. Please try again.',
    retry: 'Try again', empty: 'Your wishlist is empty.', browse: 'Continue shopping',
    products: 'Saved products', list: 'Wishlist', item: 'item', items: 'items',
    view: 'View product & choose size', remove: 'Remove', removing: 'Removing…',
    removed: 'Item removed from your wishlist.', removeError: "We couldn't remove this item. Please try again.",
    add: 'Add to wishlist', removeSaved: 'Remove from wishlist', saving: 'Updating your wishlist…',
    added: 'Product added to your wishlist.', saveError: "We couldn't update your wishlist. Please try again.",
    product: 'Saved product', productUnavailable: 'This product is currently unavailable.',
    productDetails: 'View the product for current sizes and availability.',
    productRefreshError: "We couldn't refresh product details. Open the product for the latest information.",
    share: 'Create public link', sharing: 'Creating link…', link: 'Wishlist link',
    shareNotice: 'Anyone with the link can view this list.',
    linkReady: 'Your link is ready. Copy it to share.', copy: 'Copy link', copied: 'Link copied.',
    manualCopy: 'Select and copy the link.', shareError: "We couldn't create a share link. Please try again."
  };

  var ui = {};
  ['title', 'close', 'status', 'error', 'retry', 'empty', 'browse', 'count', 'lists', 'items',
    'share', 'share-notice', 'share-url'].forEach(function (name) {
    ui[name] = dialog.querySelector('[data-frame-wishlist-' + name + ']');
  });
  if (!ui.items || !ui.close || !ui.status || !ui.error) return;
  var selectors = dialog.dataset.launchers || '.header-mobile__item--wishlist .header__icon--wishlist, .header-mobile .header__icon--wishlist, .frame-hdr-wishlist a, a.swym-advanced-header-icon';
  var apiTimeout = duration(dialog.dataset.apiTimeout, 10000);
  var sdkTimeout = duration(dialog.dataset.sdkTimeout, 12000);
  var state = { sdk: null, lists: [], lid: null, opener: null, generation: 0, mutations: 0, shareUrl: null, products: new Map() };
  var readyResolve;
  var ready = new Promise(function (resolve) { readyResolve = resolve; });
  var refreshTimer;
  var cardSelector = '.boost-sd__product-item .swym-advanced-wishlist-collections';
  var pendingCards = new WeakSet();
  var cardNotice;
  var cardNoticeTimer;

  function duration(value, fallback) {
    var n = Number(value);
    return Number.isFinite(n) && n >= 20 && n <= 30000 ? n : fallback;
  }
  function label(node, value) { if (node) node.textContent = value; }
  function setHidden(node, hidden) { if (node) node.hidden = hidden; }
  function fail(kind) { var error = new Error(kind); error.frameKind = kind; return error; }
  function normalizeError(error) {
    var message = typeof error === 'string' ? error : error && (error.message || error['error-msg']) || '';
    if (/not enabled|not allowed|unauthori[sz]ed|forbidden/i.test(message)) return fail('unavailable');
    return error && error.frameKind ? error : fail('service');
  }
  function timed(executor, ms) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () { done(reject, fail('timeout')); }, ms);
      function done(fn, value) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        fn(value);
      }
      try {
        executor(function (value) {
          if (value && !Array.isArray(value) && (value.error || value.status === 'error' || Number(value.status) >= 400 || value['error-code'])) done(reject, normalizeError(value));
          else done(resolve, value);
        }, function (error) { done(reject, normalizeError(error)); });
      } catch (error) { done(reject, normalizeError(error)); }
    });
  }
  function getSdk() {
    if (state.sdk) return Promise.resolve(state.sdk);
    return timed(function (resolve) { ready.then(resolve); }, sdkTimeout);
  }
  function api(method, args) {
    return getSdk().then(function (swat) {
      if (typeof swat[method] !== 'function') throw fail('unavailable');
      return timed(function (resolve, reject) {
        if (method === 'fetchLists') swat.fetchLists({ callbackFn: resolve, errorFn: reject });
        else if (method === 'fetch') swat.fetch(resolve);
        else swat[method].apply(swat, args.concat([resolve, reject]));
      }, apiTimeout);
    });
  }
  function rootPath() {
    var root = dialog.dataset.storeRoot || '/';
    return /^\/[a-zA-Z0-9\/_-]*$/.test(root) ? root.replace(/\/?$/, '/') : '/';
  }
  function productURL(item) {
    try {
      var url = new URL(item.du || '', location.origin);
      var localHost = location.hostname.replace(/^www\./, '');
      if (!/^https?:$/.test(url.protocol) || url.hostname.replace(/^www\./, '') !== localHost) return null;
      var pieces = url.pathname.split('/products/');
      if (pieces.length !== 2) return null;
      var handle = decodeURIComponent(pieces[1]);
      if (!handle || /[\/\\\u0000-\u001f]/.test(handle)) return null;
      return new URL(rootPath() + 'products/' + encodeURIComponent(handle), location.origin).href;
    } catch (error) { return null; }
  }
  function imageURL(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      var url = new URL(value || '', location.origin);
      return url.protocol === 'https:' ? url.href : null;
    } catch (error) { return null; }
  }
  function itemData(item) {
    return Object.assign({}, item && item.product && typeof item.product === 'object' ? item.product : {}, item);
  }
  function itemKey(item) { return String(item.epi || '') + ':' + String(item.empi || '') + ':' + String(item.du || ''); }
  function activeList() {
    return state.lists.find(function (list) { return list.lid === state.lid; }) || null;
  }
  function itemsOf(list) { return list && Array.isArray(list.listcontents) ? list.listcontents : []; }
  function listType(list) {
    if (!list || typeof list !== 'object') return 'other';
    return list.lty == null ? 'default' : typeof list.lty === 'string' ? list.lty.trim().toLowerCase() || 'default' : 'other';
  }
  function wishlistType(list) { return ['default', 'wl', 'wishlist'].indexOf(listType(list)) !== -1; }
  function diagnosticType(list) {
    var type = listType(list);
    return ['default', 'wl', 'wishlist', '_saveforlater', 'sfl', 'persistentcart', '_recommends'].indexOf(type) !== -1 ? type : 'other';
  }
  function savedEvents(products, swat) {
    var et = swat.EventTypes && (swat.EventTypes.addToWishlist || swat.EventTypes.addToWishList) || 4;
    return products.filter(function (item) { return item && (item.et == null || String(item.et) === String(et)); });
  }
  function collectionsMode(swat) {
    try {
      if (typeof swat.isCollectionsEnabled === 'function') return !!swat.isCollectionsEnabled();
    } catch (error) { return null; }
    return null;
  }
  async function readFlat() {
    var values = await api('fetch', []);
    if (!Array.isArray(values)) throw fail('service');
    if (!values.length && state.sdk.nonFetchUI === true) throw fail('unavailable');
    return savedEvents(values, state.sdk);
  }
  function setCardState(button, saved) {
    button.classList.toggle('swym-added', saved);
    button.classList.toggle('frame-wishlist-card-saved', saved);
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', saved ? copy.removeSaved : copy.add);
  }
  function syncCardButtons(products) {
    if (collectionsMode(state.sdk || {}) !== false) return;
    document.querySelectorAll(cardSelector).forEach(function (button) {
      if (pendingCards.has(button)) return;
      var card = button.closest('.boost-sd__product-item');
      var empi = card && card.getAttribute('data-product-id');
      if (!empi) return;
      setCardState(button, products.some(function (item) { return String(itemData(item).empi) === empi; }));
    });
  }
  function cardMessage(message, error) {
    if (!cardNotice) {
      cardNotice = document.createElement('div');
      cardNotice.className = 'frame-wishlist-card-notice';
      document.body.appendChild(cardNotice);
    }
    clearTimeout(cardNoticeTimer);
    cardNotice.setAttribute('role', error ? 'alert' : 'status');
    cardNotice.setAttribute('aria-live', error ? 'assertive' : 'polite');
    cardNotice.hidden = false; cardNotice.textContent = message;
    cardNotice.classList.toggle('is-error', !!error);
    cardNoticeTimer = setTimeout(function () { cardNotice.hidden = true; }, error ? 7000 : 4500);
  }
  function cardTrigger(target) {
    var button = target && target.closest ? target.closest(cardSelector) : null;
    return button && state.sdk && collectionsMode(state.sdk) === false ? button : null;
  }
  function requestProduct(href) {
    return timed(function (resolve, reject) {
      if (typeof window.fetch !== 'function') { reject(fail('service')); return; }
      window.fetch(href + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw fail(response.status === 404 ? 'productMissing' : 'service');
        return response.json();
      }).then(resolve, reject);
    }, apiTimeout);
  }
  async function toggleCard(button) {
    if (pendingCards.has(button) || button.disabled) return;
    if (state.mutations) { cardMessage(copy.saving, false); return; }
    var card = button.closest('.boost-sd__product-item');
    var link = card && card.querySelector('a[href*="/products/"]');
    var href = link && productURL({ du: link.href });
    if (!href) { cardMessage(copy.saveError, true); return; }
    var previous = null;
    pendingCards.add(button); state.mutations++; mutationControls();
    button.disabled = true; button.setAttribute('aria-busy', 'true');
    cardMessage(copy.saving, false);
    try {
      var current = await requestProduct(href);
      var variant = current && Array.isArray(current.variants) && current.variants[0];
      var expectedId = card.getAttribute('data-product-id');
      if (!current || !variant || !Number.isSafeInteger(Number(current.id)) || !Number.isSafeInteger(Number(variant.id)) ||
          Number(current.id) <= 0 || Number(variant.id) <= 0 || expectedId && String(current.id) !== expectedId) throw fail('service');
      var before = await readFlat();
      var existing = before.map(itemData).find(function (item) { return String(item.empi) === String(current.id); });
      previous = !!existing;
      setCardState(button, previous);
      var product = existing ? { epi: existing.epi, empi: existing.empi, du: existing.du } : {
        epi: Number(variant.id), empi: Number(current.id), du: href,
        dt: current.title || copy.product, iu: imageURL(current.featured_image) || '',
        pr: Number(variant.price) / 100, source: 'collections-grid'
      };
      await api(existing ? 'removeFromWishList' : 'addToWishList', [product]);
      var after = await readFlat();
      var saved = after.some(function (item) { return String(itemData(item).empi) === String(current.id); });
      if (saved === previous) throw fail('service');
      setCardState(button, saved); syncCardButtons(after);
      var flatList = state.lists.find(function (list) { return list.frameSource === 'flat'; });
      if (flatList) { flatList.listcontents = after; flatList.cnt = after.length; }
      cardMessage(saved ? copy.added : copy.removed, false);
      document.dispatchEvent(new CustomEvent('frame:wishlist-updated', { detail: { count: after.length } }));
    } catch (error) {
      if (previous != null) setCardState(button, previous);
      cardMessage(error && error.frameKind === 'timeout' ? copy.timeout : error && error.frameKind === 'unavailable' ? copy.unavailable : copy.saveError, true);
    } finally {
      button.disabled = false; button.removeAttribute('aria-busy');
      pendingCards.delete(button); state.mutations--; mutationControls();
      if (dialog.open) load();
    }
  }
  function notify(message) { label(ui.status, message || ''); }
  function clearError() { label(ui.error, ''); setHidden(ui.error, true); setHidden(ui.retry, true); }
  function showError(error, context) {
    var kind = error && error.frameKind;
    var message = kind === 'timeout' ? copy.timeout : kind === 'unavailable' ? copy.unavailable :
      context === 'remove' ? copy.removeError : context === 'share' ? copy.shareError : copy.loadError;
    label(ui.error, message);
    setHidden(ui.error, false);
    setHidden(ui.retry, context === 'remove' || context === 'share');
    notify('');
  }
  function expanded(open) {
    document.querySelectorAll(selectors).forEach(function (button) {
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-controls', dialog.id);
      button.setAttribute('aria-haspopup', 'dialog');
    });
  }
  function resetShare() {
    state.shareUrl = null;
    label(ui.share, copy.share);
    if (ui['share-url']) ui['share-url'].value = '';
    setHidden(ui['share-url'], true);
  }
  function shareAvailable() {
    if (dialog.dataset.shareEnabled !== 'true' || !state.sdk || !state.lid || !itemsOf(activeList()).length || activeList().frameSource === 'flat') return false;
    try {
      return !!(state.sdk.platform && state.sdk.platform.isLoggedIn() &&
        typeof state.sdk.markListPublic === 'function' && typeof state.sdk.generateSharedListURL === 'function');
    } catch (error) { return false; }
  }
  function syncShare() {
    var visible = shareAvailable();
    setHidden(ui.share, !visible);
    setHidden(ui['share-notice'], !visible);
  }
  function busy(value) {
    ui.items.setAttribute('aria-busy', String(value));
    if (ui.lists) ui.lists.disabled = value || !!state.mutations;
  }
  function mutationControls() {
    if (ui.lists) ui.lists.disabled = !!state.mutations || ui.items.getAttribute('aria-busy') === 'true';
    ui.items.querySelectorAll('button[data-frame-removable]').forEach(function (button) {
      button.disabled = !!state.mutations || button.dataset.frameRemovable !== 'true';
    });
    if (ui.share) ui.share.disabled = !!state.mutations;
  }
  function beginLoad() {
    clearError(); resetShare(); busy(true);
    ui.items.replaceChildren(); label(ui.count, '');
    setHidden(ui.empty, true); setHidden(ui.share, true); setHidden(ui['share-notice'], true);
    notify(copy.loading);
  }
  function renderLists() {
    if (!ui.lists) return;
    ui.lists.replaceChildren();
    state.lists.forEach(function (list) {
      var option = document.createElement('option');
      option.value = list.lid;
      option.textContent = list.lname || copy.title;
      option.selected = list.lid === state.lid;
      ui.lists.appendChild(option);
    });
    setHidden(ui.lists, state.lists.length < 2);
  }
  function render() {
    var list = activeList();
    var products = itemsOf(list);
    dialog.dataset.frameWishlistVisibleItems = String(products.length);
    ui.items.replaceChildren();
    busy(false);
    label(ui.count, products.length + ' ' + (products.length === 1 ? copy.item : copy.items));
    setHidden(ui.empty, products.length !== 0);
    products.forEach(function (original) { renderItem(itemData(original), state.lid); });
    renderLists();
    syncShare();
  }
  function renderItem(item, lid) {
    var li = document.createElement('li');
    li.className = 'frame-wishlist__item';
    li.dataset.itemKey = itemKey(item);
    var image = imageURL(item.iu);
    if (image) {
      var img = document.createElement('img');
      img.src = image; img.alt = ''; img.loading = 'lazy'; img.width = 96; img.height = 120;
      li.appendChild(img);
    }
    var details = document.createElement('div');
    details.className = 'frame-wishlist__details';
    var title = document.createElement('h3');
    title.textContent = item.dt || item.title || copy.product;
    details.appendChild(title);
    var href = productURL(item);
    var detail = document.createElement('p');
    detail.className = 'frame-wishlist__product-note';
    detail.textContent = href ? copy.productDetails : copy.productUnavailable;
    details.appendChild(detail);
    if (href) {
      var link = document.createElement('a');
      link.className = 'frame-wishlist__view';
      link.href = href;
      link.textContent = copy.view;
      link.setAttribute('aria-label', copy.view + ': ' + title.textContent);
      details.appendChild(link);
    }
    var remove = document.createElement('button');
    remove.type = 'button'; remove.className = 'frame-wishlist__remove';
    remove.textContent = copy.remove;
    remove.setAttribute('aria-label', copy.remove + ': ' + title.textContent);
    remove.dataset.frameRemovable = String(!!(item.epi && item.empi && typeof item.du === 'string' && item.du));
    remove.disabled = !!state.mutations || remove.dataset.frameRemovable !== 'true';
    remove.addEventListener('click', function () { removeItem(lid, item, li, remove); });
    details.appendChild(remove);
    li.appendChild(details);
    ui.items.appendChild(li);
    if (href) refreshProduct(href, li, title, detail);
  }
  function refreshProduct(href, row, title, detail) {
    if (typeof window.fetch !== 'function') { detail.textContent = copy.productRefreshError; return; }
    if (!state.products.has(href)) {
      state.products.set(href, requestProduct(href));
    }
    state.products.get(href).then(function (product) {
      if (!row.isConnected) return;
      if (!product || typeof product.title !== 'string') throw fail('service');
      title.textContent = product.title;
      var link = row.querySelector('a');
      if (link) link.setAttribute('aria-label', copy.view + ': ' + product.title);
      row.querySelector('button').setAttribute('aria-label', copy.remove + ': ' + product.title);
      var src = imageURL(product.featured_image);
      var img = row.querySelector('img');
      if (src) {
        if (!img) { img = document.createElement('img'); img.alt = ''; img.loading = 'lazy'; img.width = 96; img.height = 120; row.prepend(img); }
        img.src = src;
      } else if (img) img.remove();
    }).catch(function (error) {
      if (!row.isConnected) return;
      detail.textContent = error && error.frameKind === 'productMissing' ? copy.productUnavailable : copy.productRefreshError;
      if (error && error.frameKind === 'productMissing') {
        var link = row.querySelector('a');
        if (link) link.remove();
      }
    });
  }
  async function load() {
    var generation = ++state.generation;
    beginLoad(); state.products = new Map();
    dialog.dataset.frameWishlistReadState = 'loading';
    ['Mode', 'RawLists', 'FilteredLists', 'ListTypes', 'RawItems', 'FilteredItems', 'VisibleItems', 'SdkReadSkipped'].forEach(function (name) {
      dialog.dataset['frameWishlist' + name] = 'pending';
    });
    try {
      var swat = await getSdk();
      if (generation !== state.generation || !dialog.open) return;
      var collections = collectionsMode(swat);
      dialog.dataset.frameWishlistCollections = collections == null ? 'unknown' : String(collections);
      if (collections === false) {
        dialog.dataset.frameWishlistMode = 'flat';
        dialog.dataset.frameWishlistRawLists = 'not-requested';
        dialog.dataset.frameWishlistFilteredLists = 'not-requested';
        dialog.dataset.frameWishlistListTypes = 'not-requested';
        var flat = await api('fetch', []);
        if (generation !== state.generation || !dialog.open) return;
        if (!Array.isArray(flat)) throw fail('service');
        var saved = savedEvents(flat, swat);
        dialog.dataset.frameWishlistRawItems = String(flat.length);
        dialog.dataset.frameWishlistFilteredItems = String(saved.length);
        dialog.dataset.frameWishlistSdkReadSkipped = typeof swat.nonFetchUI === 'boolean' ? String(swat.nonFetchUI) : 'unknown';
        if (!flat.length && swat.nonFetchUI === true) throw fail('unavailable');
        state.lists = [{ lid: 'frame-default-wishlist', lname: copy.title, frameSource: 'flat', listcontents: saved, cnt: saved.length }];
        syncCardButtons(saved);
      } else {
        dialog.dataset.frameWishlistMode = 'lists';
        dialog.dataset.frameWishlistSdkReadSkipped = 'not-applicable';
        var lists = await api('fetchLists', []);
        if (generation !== state.generation || !dialog.open) return;
        if (!Array.isArray(lists)) throw fail('service');
        var filtered = lists.filter(function (list) { return list && typeof list.lid === 'string' && wishlistType(list); });
        dialog.dataset.frameWishlistRawLists = String(lists.length);
        dialog.dataset.frameWishlistFilteredLists = String(filtered.length);
        dialog.dataset.frameWishlistListTypes = Array.from(new Set(lists.map(diagnosticType))).sort().join(',') || 'none';
        dialog.dataset.frameWishlistRawItems = String(lists.reduce(function (sum, list) { return sum + itemsOf(list).length; }, 0));
        dialog.dataset.frameWishlistFilteredItems = String(filtered.reduce(function (sum, list) { return sum + itemsOf(list).length; }, 0));
        if (lists.some(function (list) { return diagnosticType(list) === 'other'; }) && !filtered.length) throw fail('service');
        state.lists = filtered.map(function (list) { return Object.assign({}, list); });
      }
      if (!state.lists.some(function (list) { return list.lid === state.lid; })) {
        state.lid = state.lists.length ? state.lists[0].lid : null;
      }
      await completeContents(generation);
      if (generation !== state.generation || !dialog.open) return;
      render(); notify(''); dialog.dataset.frameWishlistReadState = 'ready';
    } catch (error) {
      if (generation !== state.generation || !dialog.open) return;
      busy(false);
      setHidden(ui.empty, true);
      showError(error, 'load');
      dialog.dataset.frameWishlistReadState = 'error';
    }
  }
  async function completeContents(generation) {
    var list = activeList();
    if (!list || (Array.isArray(list.listcontents) && !(Number(list.cnt) > list.listcontents.length))) return;
    var contents = await api('fetchListCtx', [{ lid: list.lid }]);
    if (generation !== state.generation) return;
    if (!Array.isArray(contents)) throw fail('service');
    list.listcontents = contents;
  }
  async function removeItem(lid, item, row, button) {
    if (button.disabled) return;
    var generation = state.generation;
    var next = row.nextElementSibling || row.previousElementSibling;
    var nextKey = next && next.dataset.itemKey;
    clearError(); state.mutations++;
    mutationControls();
    button.disabled = true; button.textContent = copy.removing;
    try {
      var targetList = state.lists.find(function (candidate) { return candidate.lid === lid; });
      if (!targetList) throw fail('service');
      var product = { epi: item.epi, empi: item.empi, du: item.du };
      if (targetList.frameSource === 'flat') {
        await api('removeFromWishList', [product]);
        var saved = await readFlat();
        if (saved.some(function (entry) { var value = itemData(entry); return String(value.epi) === String(item.epi) && String(value.empi) === String(item.empi); })) throw fail('service');
        targetList.listcontents = saved;
        syncCardButtons(saved);
      } else await api('deleteFromList', [lid, product]);
      var list = state.lists.find(function (candidate) { return candidate.lid === lid; });
      if (list) list.listcontents = itemsOf(list).filter(function (entry) { return itemKey(itemData(entry)) !== itemKey(item); });
      resetShare();
      if (dialog.open && state.lid === lid && generation === state.generation) {
        render(); notify(copy.removed);
        var target = nextKey && Array.from(ui.items.children).find(function (entry) {
          return entry.dataset.itemKey === nextKey;
        });
        (target && target.querySelector('button') || ui.close).focus();
      }
      document.dispatchEvent(new CustomEvent('frame:wishlist-updated', { detail: { count: itemsOf(activeList()).length } }));
    } catch (error) {
      button.disabled = false; button.textContent = copy.remove;
      if (dialog.open && generation === state.generation) { showError(error, 'remove'); if (button.isConnected) button.focus(); }
    } finally {
      state.mutations--;
      mutationControls();
      if (dialog.open && generation !== state.generation) load();
    }
  }
  async function share() {
    if (!shareAvailable() || ui.share.disabled) return;
    clearError();
    if (state.shareUrl) {
      try {
        if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') throw fail('clipboard');
        await navigator.clipboard.writeText(state.shareUrl);
        notify(copy.copied);
      } catch (error) {
        notify(copy.manualCopy);
        ui['share-url'].focus(); ui['share-url'].select();
      }
      return;
    }
    var lid = state.lid;
    state.mutations++;
    mutationControls();
    ui.share.disabled = true; label(ui.share, copy.sharing);
    try {
      await api('markListPublic', [lid]);
      var value = await api('generateSharedListURL', [lid]);
      var url = new URL(value, location.origin);
      if (url.protocol !== 'https:' || url.hostname.replace(/^www\./, '') !== location.hostname.replace(/^www\./, '')) throw fail('service');
      if (lid !== state.lid || !dialog.open) return;
      state.shareUrl = url.href;
      ui['share-url'].value = url.href;
      setHidden(ui['share-url'], false);
      label(ui.share, copy.copy); notify(copy.linkReady);
    } catch (error) { label(ui.share, copy.share); if (dialog.open) showError(error, 'share'); }
    finally { state.mutations--; mutationControls(); }
  }
  function visibleFocusable(node) {
    if (!node || !node.isConnected || node.disabled || node.closest('[hidden]')) return false;
    for (var parent = node; parent && parent.nodeType === 1; parent = parent.parentElement) {
      var style = getComputedStyle(parent);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    }
    return true;
  }
  function focusables() {
    return Array.from(dialog.querySelectorAll('button, a[href], select, input, [tabindex]')).filter(function (node) {
      return node.getAttribute('tabindex') !== '-1' && visibleFocusable(node);
    });
  }
  function open(opener) {
    if (dialog.open) return;
    state.opener = opener || document.activeElement;
    if (typeof dialog.showModal !== 'function') return;
    dialog.showModal();
    document.documentElement.classList.add('frame-wishlist-open');
    expanded(true); ui.close.focus(); load();
  }
  function cleanClose() {
    state.generation++;
    document.documentElement.classList.remove('frame-wishlist-open');
    expanded(false);
    if (visibleFocusable(state.opener)) state.opener.focus();
    state.opener = null;
  }
  function close() { if (dialog.open) dialog.close(); }
  function launcher(target) { return target && target.closest ? target.closest(selectors) : null; }

  label(ui.title, copy.title); label(ui.close, '×'); ui.close.setAttribute('aria-label', copy.close);
  label(ui.retry, copy.retry); label(ui.browse, copy.browse);
  label(ui.empty && ui.empty.querySelector('p'), copy.empty);
  label(ui.share, copy.share); label(ui['share-notice'], copy.shareNotice);
  if (ui['share-url']) ui['share-url'].setAttribute('aria-label', copy.link);
  if (ui.lists) ui.lists.setAttribute('aria-label', copy.list);
  ui.items.setAttribute('aria-label', copy.products);
  dialog.dir = ar ? 'rtl' : 'ltr';
  if (ui.browse) ui.browse.href = rootPath() + 'collections/all';

  document.addEventListener('click', function (event) {
    var cardButton = cardTrigger(event.target);
    if (cardButton) { event.preventDefault(); event.stopImmediatePropagation(); toggleCard(cardButton); return; }
    var trigger = launcher(event.target);
    if (!trigger || typeof dialog.showModal !== 'function') return;
    event.preventDefault(); event.stopImmediatePropagation(); open(trigger);
  }, true);
  document.addEventListener('keydown', function (event) {
    var cardButton = cardTrigger(event.target);
    if (cardButton && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault(); event.stopImmediatePropagation(); toggleCard(cardButton); return;
    }
    var trigger = launcher(event.target);
    if (!trigger || (event.key !== 'Enter' && event.key !== ' ') || typeof dialog.showModal !== 'function') return;
    event.preventDefault(); event.stopImmediatePropagation(); open(trigger);
  }, true);
  dialog.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    var nodes = focusables();
    if (!nodes.length) { event.preventDefault(); ui.close.focus(); return; }
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      event.preventDefault(); first.focus();
    }
  });
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
  dialog.addEventListener('close', cleanClose);
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    var rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  ui.close.addEventListener('click', close);
  if (ui.retry) ui.retry.addEventListener('click', load);
  if (ui.share) ui.share.addEventListener('click', share);
  if (ui.lists) ui.lists.addEventListener('change', async function () {
    if (state.mutations) return;
    state.lid = ui.lists.value;
    beginLoad();
    var generation = ++state.generation;
    try { await completeContents(generation); if (generation === state.generation && dialog.open) { render(); notify(''); } }
    catch (error) { if (generation === state.generation && dialog.open) { busy(false); showError(error, 'load'); } }
  });

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    state.sdk = swat; readyResolve(swat);
    if (!swat.evtLayer || typeof swat.evtLayer.addEventListener !== 'function') return;
    var names = ['sw:addedtowishlist', 'sw:removedfromwishlist', 'sw:customerinforefreshed', 'sw:customerInfoRefreshed'];
    if (swat.JSEvents) ['addedToWishlist', 'removedFromWishlist', 'customerInfoRefreshed'].forEach(function (name) {
      if (typeof swat.JSEvents[name] === 'string') names.push(swat.JSEvents[name]);
    });
    Array.from(new Set(names)).forEach(function (eventName) {
      swat.evtLayer.addEventListener(eventName, function () {
        if (!dialog.open || state.mutations) return;
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(load, 120);
      });
    });
  });
})();
